import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import { parseId } from '@/helper/id'
import {
    detailsQueryKeyPrefix,
    usersQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'

export const userDetailsQueryKeyPrefix = [
    usersQueryKeyPrefix,
    detailsQueryKeyPrefix,
] as const

export const userDetailsOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    id: string,
    deletedItemSelection: DeletedItemSelection
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...userDetailsQueryKeyPrefix, id, deletedItemSelection],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.user)

            const response = await clients.user.getUser(
                { deletedItemSelection, id: parseId(id) },
                { signal }
            )

            return response
        },
    })

export const useUserDetails = (
    id: string,
    deletedItemSelection: DeletedItemSelection
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(
        userDetailsOptions(clients, id, deletedItemSelection)
    )
}
